var map = {
	"./cv-corpus-1": 6564,
	"./cv-corpus-1.js": 6564,
	"./cv-corpus-2": 3280,
	"./cv-corpus-2.js": 3280,
	"./cv-corpus-3": 4605,
	"./cv-corpus-3.js": 4605,
	"./cv-corpus-4-2019-12-10": 6398,
	"./cv-corpus-4-2019-12-10.js": 6398,
	"./cv-corpus-5-2020-06-22": 578,
	"./cv-corpus-5-2020-06-22.js": 578,
	"./cv-corpus-5-singleword": 2654,
	"./cv-corpus-5-singleword.js": 2654,
	"./cv-corpus-5.1-2020-06-22": 953,
	"./cv-corpus-5.1-2020-06-22.js": 953,
	"./cv-corpus-5.1-singleword": 9891,
	"./cv-corpus-5.1-singleword.js": 9891,
	"./cv-corpus-6.0-2020-12-11": 192,
	"./cv-corpus-6.0-2020-12-11.js": 192,
	"./cv-corpus-6.0-singleword": 3736,
	"./cv-corpus-6.0-singleword.js": 3736,
	"./cv-corpus-6.1-2020-12-11": 106,
	"./cv-corpus-6.1-2020-12-11.js": 106,
	"./cv-corpus-6.1-singleword": 6910,
	"./cv-corpus-6.1-singleword.js": 6910,
	"./cv-corpus-7.0-2021-07-21": 8025,
	"./cv-corpus-7.0-2021-07-21.js": 8025,
	"./cv-corpus-7.0-singleword": 4113,
	"./cv-corpus-7.0-singleword.js": 4113,
	"./cv-corpus-8.0-2022-01-19": 7971,
	"./cv-corpus-8.0-2022-01-19.js": 7971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3188;